export default __webpack_public_path__ + "static/media/logo_desktop.d435b4b7.svg";